<template>
  <v-app style="background-color: #FCF3C3">

    <nav>
      <v-toolbar :height="toolbarHeight" color="#EAD1A1" app>
        <v-spacer class="hidden-md-and-up"></v-spacer>
        <v-toolbar-title class="headline text-uppercase">
          <div>
            <router-link style="text-decoration: none;" to="/">
              <div v-show="showNavLogo" class="taps-small-logo">
                <span class="taps-small-logo-title-text">T.A.P.S</span><br style="height:20px;"/>
                <span class="taps-small-logo-subtitle-text">Home Repair & Remodeling</span>
              </div>
            </router-link>
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn
                  v-for="item in menu"
                  :key="item.icon"
                  :to="item.link"
                  flat
          >{{ item.title }}</v-btn>
        </v-toolbar-items>
        <v-menu class="hidden-md-and-up">
          <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
          <v-list>
            <v-list-tile v-for="item in menu" :key="item.icon">
              <v-list-tile-content>
                <v-list-tile-title><router-link :to="item.link" style="text-decoration:none; color: black;">{{ item.title }}</router-link></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-toolbar>
    </nav>

    <v-content>
          <br>
            <router-view></router-view>
    </v-content>
    <br />

    <v-footer
            dark
            height="auto"
            style="background-color: #C9B080"
    >
      <v-card
              flat
              class="text-xs-center"
              style="width: 100%; background-color: #C9B080"
      >
        <v-card-text class="pt-0">
          <v-layout wrap>
            <v-flex xs12>&nbsp;</v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs11 style="text-align: left;">
              <span class="footer-header">CONTACT US:</span><br>
              <span class="footer-text">{{siteName}} {{siteSubname}}</span><br>
              <span class="footer-text">{{city}}, {{state}} {{zip}}</span><br>
              <v-icon size="20">phone</v-icon><span style="color: #FFFFFF; font-weight: bold; font-size: 10pt;"><a :href="phoneLink">{{phoneValue}}</a></span>

            </v-flex>
            <v-flex xs4>
              <span style="color: #FFFFFF; font-weight: bold; font-size: 12pt;">&nbsp;</span><br>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text" style="text-align: left">
          <v-layout>
          <v-flex xs1></v-flex>
          <v-flex xs11>
            &copy;2019 — <strong>{{siteName}} {{siteSubname}}</strong>
          </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
  import { sync } from 'vuex-pathify';
  const axios = require('axios');

  export default {
  name: 'App',
  components: {},
  data() {
    return {
      menu: [
        {icon: 'home', title: 'Home', link: '/home'},
        {icon: 'info', title: 'Gallery', link: '/gallery'}
      ]
    }
  },
  computed: {
    showNavLogo: function() {
      if (this.$route.path  == '/') {
        return false;
      }  else if (this.$route.path == '/home') {
        return false;
      } else {
        return true;
      }
    },
    toolbarHeight: function() {
      if (this.$route.path  == '/') {
        return 50;
      }  else if (this.$route.path == '/home') {
        return 50;
      } else {
        return 100;
      }
    },
    ...sync(['siteName', 'siteSubname', 'phoneLink', 'phoneValue', 'city', 'state', 'zip', 'serviceUrl', 'street',
      'navbarLogo', 'imageUrl', 'serviceEndpoints.GET_SITE_ATTRIBUTES', 'contactEmail', 'navbarLargeLogo',
      'firstRedBlock', 'secondRedBlock', 'descriptorImage'])
  },
    mounted: function () {
      let me = this;
      axios.get(this.serviceUrl + this.GET_SITE_ATTRIBUTES)
              .then(function (response) {
                let config = response.data.payload;
                if ((config !== undefined) || (config !== null)) {
                  config.forEach(attribute => {
                    if ((attribute !== undefined) || (attribute !== null)) {
                      if (attribute.name === 'city') {
                        me.city = attribute.value;
                      } else if (attribute.name === 'street') {
                        me.street = attribute.value;
                      } else if (attribute.name === 'state') {
                        me.state = attribute.value;
                      } else if (attribute.name === 'zip') {
                        me.zip = attribute.value;
                      } else if (attribute.name === 'phone_value') {
                        me.phoneValue = attribute.value;
                      } else if (attribute.name === 'phone_link') {
                        me.phone_link = attribute.value;
                      } else if (attribute.name === 'contact_email') {
                        me.contactEmail = attribute.value;
                      } else if (attribute.name === 'site_name') {
                        me.siteName = attribute.value;
                      } else if (attribute.name === 'site_subname') {
                        me.siteSubname = attribute.value;
                      } else if (attribute.name === 'navbar_logo') {
                        me.navbarLogo = attribute.value;
                      } else if (attribute.name === 'navbar_large_logo') {
                        me.navbarLargeLogo = attribute.value;
                      } else if (attribute.name === 'redblock_one') {
                        me.firstRedBlock = attribute.value;
                      } else if (attribute.name === 'redblock_two') {
                        me.secondRedBlock = attribute.value;
                      } else if (attribute.name === 'descriptor_image') {
                        me.descriptorImage = attribute.value;
                      }
                    }
                  })
                }
              })
              .catch(function (error) {
                console.log(error);
              })
    }
  }
</script>

<style>
  .footer-text {
    color: #FFFFFF;
    font-weight: bold;
    font-size: 10pt;
    text-decoration: none;
  }
  .footer-header {
    color: #FFFFFF;
    font-weight: bold;
    font-size: 12pt;
  }
  .taps-small-logo {
    text-align: center;
  }
  .taps-small-logo-title-text {
    color: #DB1918;
    text-decoration: none;
    font-family: Serif;
    font-weight: bold;;
    font-size: 38pt;
    margin-bottom: 0px;
    padding-bottom: 0px;
    vertical-align: bottom;
  }
  .taps-small-logo-subtitle-text {
    margin-top: 0px;
    color: #000;
    font-family: Arial;
    font-size: 12pt;
    padding-top: 0px;
    vertical-align: top;
    font-weight: bold;
  }
</style>
